module.exports = __webpack_public_path__ + "static/media/needs.d73d50c8.png";